import { render, staticRenderFns } from "./redeployment.vue?vue&type=template&id=535252b0"
import script from "./redeployment.vue?vue&type=script&lang=js"
export * from "./redeployment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports